import { render, staticRenderFns } from "./ReportsPrice.vue?vue&type=template&id=61f7f86b&"
import script from "./ReportsPrice.vue?vue&type=script&lang=js&"
export * from "./ReportsPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports